import { render, staticRenderFns } from "./EstoqueLista.vue?vue&type=template&id=d368e78e&scoped=true&"
import script from "./EstoqueLista.vue?vue&type=script&lang=js&"
export * from "./EstoqueLista.vue?vue&type=script&lang=js&"
import style0 from "./EstoqueLista.vue?vue&type=style&index=0&id=d368e78e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d368e78e",
  null
  
)

export default component.exports